import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { SignInTitle } from '~/components/common';
import { Header } from '~/components/common/Header';
import Progress from '../Progress/Progress';

export interface LayoutProps {
  title: string;
  children: React.ReactNode;
  gap?: number;
  steps?: number;
  currentStep?: number;
  onPrevClick?: () => void;
}

export default function Layout({
  title,
  gap = 24,
  children,
  steps,
  currentStep,
  onPrevClick,
}: LayoutProps) {
  return (
    <>
      <Header.Root>
        <Header.Section>
          <Header.PrevButton onPrevClick={onPrevClick} />
        </Header.Section>
      </Header.Root>
      <Container>
        {steps && (
          <Progress totalSteps={steps} currentStep={currentStep || 0} />
        )}
        <SignInTitle title={title} mb={gap} />
        <Inner>{children}</Inner>
      </Container>
    </>
  );
}

export const Container = styled.div`
  ${({ theme }) => css`
    position: relative;
    width: 100%;
    padding: ${theme.layout.chat_header_height} 16px 0;
  `}
`;

export const Inner = styled.div`
  flex: 1 0 auto;
  width: 100%;
`;
